import { createSlice } from "@reduxjs/toolkit";
import LocalStorage from "../../utils/localStorage";

const customCollectionsSlice = createSlice({
  name: "customCollections",
  initialState: {
    data: LocalStorage.getCustomCollections() || [],
    mode: "add",
    customCollectionToEdit: null,
  },
  reducers: {
    addCustomCollection: (state, action) => {
      state.data.push(action.payload);
      LocalStorage.setCustomCollections(state.data);
    },
    removeCustomCollection: (state, action) => {
      const index = state.data.findIndex(
        (customCollection) => customCollection.id === action.payload
      );
      if (index > -1) {
        state.data.splice(index, 1);
        LocalStorage.setCustomCollections(state.data);
      }
    },
    editCustomCollection: (state, action) => {
      const { id, selectedCharts } = action.payload;

      const relevantCollection = state.data.find(
        (customCollection) => customCollection.id === id
      );

      if (relevantCollection) {
        relevantCollection.selectedCharts = selectedCharts;
      }
    },
    setMode: (state, action) => {
      state.mode = action.payload;
    },
    setCustomCollectionToEdit: (state, action) => {
      state.customCollectionToEdit = action.payload;
    },
  },
});

export const {
  addCustomCollection,
  removeCustomCollection,
  setMode,
  setCustomCollectionToEdit,
  editCustomCollection,
} = customCollectionsSlice.actions;

export default customCollectionsSlice.reducer;
